export default "__VITE_ASSET__REj$efH5__"